import { render, staticRenderFns } from "./pagesbg.vue?vue&type=template&id=7c621f6c&"
import script from "./pagesbg.vue?vue&type=script&lang=js&"
export * from "./pagesbg.vue?vue&type=script&lang=js&"
import style0 from "./pagesbg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports